export default __webpack_public_path__ + "static/4-d580a48e4dacefaa87515b2d130de07b.jpg";